/**
 * Soft Soft network / Wi‑Fi draft store — localhost preview only.
 * Production hosts must fail closed; Soft≠Live never paints as Live board state.
 */
import { isLocalHost } from "./pathseal.js";

const KEY = "croc-soft-machine-net-v1";

function readAll() {
  try {
    const raw = sessionStorage.getItem(KEY);
    const obj = raw ? JSON.parse(raw) : {};
    return obj && typeof obj === "object" ? obj : {};
  } catch {
    return {};
  }
}

function writeAll(obj) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(obj || {}));
  } catch {
    /* ignore */
  }
}

export function softNetGet(deviceId) {
  if (!isLocalHost()) return null;
  const did = String(deviceId || "").trim();
  if (!did) return null;
  const row = readAll()[did];
  if (!row || typeof row !== "object") return null;
  return {
    ip: String(row.ip || "").trim(),
    gateway: String(row.gateway || "").trim(),
    subnet: String(row.subnet || "").trim(),
    ssid: String(row.ssid || "").trim(),
    medium: String(row.medium || "").trim(),
    pskQueued: !!row.pskQueued,
    honesty: "soft_preview",
  };
}

export function softNetPut(deviceId, patch) {
  if (!isLocalHost()) return null;
  const did = String(deviceId || "").trim();
  if (!did) return null;
  const all = readAll();
  const prev = all[did] && typeof all[did] === "object" ? all[did] : {};
  const next = {
    ip: String((patch && patch.ip != null ? patch.ip : prev.ip) || "").trim(),
    gateway: String((patch && patch.gateway != null ? patch.gateway : prev.gateway) || "").trim(),
    subnet: String((patch && patch.subnet != null ? patch.subnet : prev.subnet) || "").trim(),
    ssid: String((patch && patch.ssid != null ? patch.ssid : prev.ssid) || "").trim(),
    medium: String((patch && patch.medium != null ? patch.medium : prev.medium) || "").trim(),
    pskQueued: !!(patch && patch.pskQueued != null ? patch.pskQueued : prev.pskQueued),
    updatedAt: new Date().toISOString(),
  };
  all[did] = next;
  writeAll(all);
  return { ...next, honesty: "soft_preview" };
}

/**
 * Soft Soft · firmware SSID scan over LAN when Wi-Fi · LAN both live.
 * Soft≠Live: never invent as Live radio results outside localhost preview.
 */
export function softWifiScanViaLan(deviceId, claimedSsid = "") {
  if (!isLocalHost()) return [];
  const did = String(deviceId || "").trim();
  const claimed = String(claimedSsid || "").trim();
  const pool = [
    { id: "Sentinel-Gate", rssi: -46 },
    { id: "Croc-Ops", rssi: -61 },
    { id: "Depot-Store", rssi: -68 },
    { id: "Guest-AP", rssi: -78 },
  ];
  if (claimed && !pool.some((p) => p.id === claimed)) {
    pool.unshift({ id: claimed, rssi: -44 });
  }
  return pool.map((p) => ({
    id: p.id,
    label: p.id,
    say: [
      "RSSI " + p.rssi,
      claimed && p.id === claimed ? "matches claimed" : "",
      did ? ("via LAN · " + did.slice(-4)) : "via LAN",
    ].filter(Boolean).join(" · "),
    match: !!(claimed && p.id === claimed),
  }));
}
